import React, { useRef } from "react";

import { Mode, TRANSFORMABLE_AREA_CLASSNAME } from "../../constants/TransformerConstants";
import Handles from "./Handles";
import Outlines from "./Outlines";
import LockedElements from "./LockedElements";
import { toZoomedSpace } from "@/utils/ZoomUtils";

const STROKE_WIDTH = 1;

const getRotateClass = (angle) =>
  (angle > -23 && angle <= 22) || (angle > 337 && angle <= 360)
    ? "rotate-0"
    : angle > 22 && angle <= 67
    ? "rotate-45"
    : angle > 67 && angle <= 112
    ? "rotate-90"
    : angle > 112 && angle <= 157
    ? "rotate-135"
    : (angle > -203 && angle <= -158) || (angle > 157 && angle <= 202)
    ? "rotate-180"
    : (angle > -158 && angle <= -113) || (angle > 202 && angle <= 247)
    ? "rotate-225"
    : (angle > -113 && angle <= -68) || (angle > 247 && angle <= 292)
    ? "rotate-270"
    : (angle > -68 && angle <= -23) || (angle > 292 && angle <= 337)
    ? "rotate-315"
    : "rotate-0";

const getMatrixCSS = (matrix) => `matrix(${matrix.join(" ")})`;

const Tool = ({
  targets,
  transforming = false,
  tool,
  mode,
  layout,
  lockedTargets,
  moveStart,
  handleMode,
  resizeStart,
  rotateStart,
  onUnlockElement,
  onClickBehind,
  zoom,
  scrollerRef,
}) => {
  const transformerRef = useRef();
  const tStyle = {
    position: "absolute",
    pointerEvents: transforming ? "auto" : "none",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: "100%",
    height: "100%",
  };

  const allowMove = (event) => {
    let move = true;

    const transElem = transformerRef.current;
    transElem.style.display = "none";

    if (onClickBehind) {
      move = !onClickBehind(event);
    }
    transElem.style.display = "block";

    return move;
  };

  const gStyle = {
    pointerEvents: "all",
  };

  const { w: toolWidth, h: toolHeight, a: toolAngle, matrix } = tool;

  // todo: pull styles into a module and pass these as css vars (if supported)
  const strokeWidth = Math.max(toZoomedSpace(STROKE_WIDTH, zoom), STROKE_WIDTH);

  return (
    <svg
      className={`${layout} ${TRANSFORMABLE_AREA_CLASSNAME}`}
      ref={transformerRef}
      style={tStyle}
    >
      <g
        style={gStyle}
        fill="none"
        transform={getMatrixCSS(matrix)}
        className={`${getRotateClass(toolAngle)}`}
      >
        <rect
          className="transformer-outline"
          x="0"
          y="0"
          width={toolWidth}
          height={toolHeight}
          strokeWidth={strokeWidth}
          onPointerDown={moveStart(allowMove)}
        />
        <Outlines targets={targets} strokeWidth={strokeWidth} />
        <Handles
          width={toolWidth}
          height={toolHeight}
          handleMode={handleMode}
          multi={mode === Mode.MULTI}
          rotateStart={rotateStart}
          resizeStart={resizeStart}
          zoom={zoom}
          matrix={matrix}
          transforming={transforming}
          scrollerRef={scrollerRef}
        />
      </g>
      <LockedElements targets={lockedTargets} onUnlockElement={onUnlockElement} />
    </svg>
  );
};

export default Tool;
